import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdicionaisEDescontosListarRoutingModule } from './adicionais-e-descontos-listar-routing.module';
import { AdicionaisEDescontosListarComponent } from './adicionais-e-descontos-listar.component';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';


@NgModule({
  declarations: [
    AdicionaisEDescontosListarComponent
  ],
  imports: [
    CommonModule,
    AdicionaisEDescontosListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    DropdownModule,
    DividerModule,
    MessagesModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    CalendarModule
  ],
  providers: [ConfirmationService]
})
export class AdicionaisEDescontosListarModule { }
